module.exports = __webpack_public_path__ + "img/4.168bce5f.png";